export default function (value) {
    if (!value) {
        return ''
    }
    return new Date(value.replace(/-/g, '/')) > new Date('2998-12-31T23:59:59.00Z')
        ? '无限制'
        : value
}